export default __webpack_public_path__ + "static/media/icon_pedidos_posologia.20cd6da5.svg";